<template lang="html">
  <div>
    <nav class="navbar navbar-default navbar-fixed-top">
      <div class="container" v-loading="isUserLoading">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>

          <router-link class="navbar-brand" :to="{ name: 'dashboard.index' }" exact>
            Cerberus
          </router-link>
        </div>

        <div id="navbar" class="navbar-collapse collapse">
          <ul class="nav navbar-nav">
            <router-link tag="li" :to="{ name: app.route }" v-for="app in menus.apps" :key="app.route">
              <a>{{ app.name }}</a>
            </router-link>
          </ul>

          <ul class="nav navbar-nav navbar-right">
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                Pacotes <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <router-link tag="li" :to="{ name: 'packages.type' }" exact>
                  <a>Tipos</a>
                </router-link>

                <router-link tag="li" :to="{ name: 'packages.group' }" exact>
                  <a>Grupos</a>
                </router-link>

                <router-link tag="li" :to="{ name: 'packages.module' }" exact>
                  <a>Módulos</a>
                </router-link>
              </ul>
            </li>

            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                Segurança <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <router-link tag="li" :to="{ name: 'security.agents' }" exact>
                  <a>Agentes</a>
                </router-link>

                <router-link tag="li" :to="{ name: 'security.roles' }" exact>
                  <a>Papéis</a>
                </router-link>

                <router-link tag="li" :to="{ name: 'security.permissions' }" exact>
                  <a>Permissões</a>
                </router-link>
              </ul>
            </li>

            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                {{ user.name }} <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <li><a href @click="logout()">Sair</a></li>
              </ul>
            </li>
          </ul>
        </div><!--/.nav-collapse -->
      </div>
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { isEmpty } from 'lodash'
import { logout as userLogout } from '@/app/auth/services'

export default {
  name: 'navbar',
  data () {
    return {
      menus: {
        apps: [
          { name: 'Clientes', route: 'customer.index' },
          { name: 'Contratos', route: 'contract.index' },
          { name: 'Licenças', route: 'license.index' },
          { name: 'Planos', route: 'plans.index' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.Auth.user
    }),

    isUserLoading () {
      return isEmpty(this.user.name)
    }
  },
  methods: {
    logout () {
      userLogout().then(() => {
        this.$router.push({ name: 'auth.singin' })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/root/navbar.vue